import React from 'react';
import './Grid.scss';

export type GridProps = {
    columns: number;
    className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const Grid: React.FC<GridProps> = ({
    children,
    columns,
    className
    }) => {
    return (
        <div className={`grid ${className ?? ''}`} data-columns={columns}>
            {children}
        </div>
    );
};
